<template>
  <ol class="est-room__steps">
    <li v-for="(step, index) in steps"
        :key="step.key"
        class="est-room__step"
        :class="'is-' + step.state"
        :aria-current="step.state === 'active' ? 'step' : null">
      <span class="est-room__step-node" aria-hidden="true">
        <font-awesome-icon v-if="step.state === 'done'" icon="fa-solid fa-check" />
        <font-awesome-icon v-else-if="step.state === 'danger'" icon="fa-solid fa-exclamation" />
        <template v-else>{{ index + 1 }}</template>
      </span>
      <span class="est-room__step-label">{{ step.label }}</span>
    </li>
  </ol>
</template>

<script>
  // Hazırlık rayı: "neredeyim, ne kaldı" sorusunun tek bakışta cevabı. Üç adım
  // (cihazlar · karşı taraf · görüşme); adımın hâli `done | active | pending |
  // danger`tır ve çağıranın bağlantı/izin durumundan türer. Ray tek başına
  // yönlendirmez — ne yapılacağını `next` bloğu söyler.
  export default {
    name: 'MeetingStepsComponent',
    props: {
      steps: {
        type: Array,
        required: true
      }
    }
  }
</script>
